var config = {
  endpoint: 'reallygreatrate.com'
};

export default config;